import { render, staticRenderFns } from "./QuestionExerciseManage.vue?vue&type=template&id=245d3820&scoped=true&"
import script from "./QuestionExerciseManage.vue?vue&type=script&lang=js&"
export * from "./QuestionExerciseManage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionExerciseManage.vue?vue&type=style&index=0&id=245d3820&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245d3820",
  null
  
)

export default component.exports